Vue.component('MpModuleCommentForm', {
    props: {
        action: String,
        title: String,
        authorLabel: String,
        emailLabel: String,
        webLabel: String,
        privacityLabel: String,
        sendLabel: String,
        adviseTitle: String,
        adviseContent: String,
        userName: String,
        userEmail: String,
        token: String
    },
    data: function() {
        return {
            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',

            author: '',
            email: '',
            web: '',
            comment: '',
            privacity: false,
            fsecure: '',

            validated: false,

            errors: [],
            successMessage: '',

            isLegalShown: false,
            isInitialized: false,
        };
    },
    computed: {
        authorCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.author);
        },
        emailCheck: function() {
            return !this.validated || FormValidator.isValidEmail(this.email);
        },
        commentCheck: function() {
            return !this.validated || !FormValidator.isEmpty(this.comment);
        },
        privacityCheck: function() {
            return (!this.validated || this.privacity);
        },
        formData: function() {
            return Serializer.serialize({
                'author': this.author,
                'email': this.email,
                'web': this.web,
                'comment': this.comment,
                'tk': this.token,
                'privacity': this.privacity,
                'fsecure': this.fsecure
            });
        }
    },
    methods: {

        showLegalConditions: function(ev) {
            if (ev.target.tagName === 'A') {
                ev.preventDefault();
                this.$emit('open');
            }
        },

        cleanErrors: function() {
            this.errors = [];
        },

        addError: function(errorMsg) {
            if (this.errors.length > 0) {
                return;
            }

            this.errors.push(errorMsg);
        },

        validateForm: function() {
            // TODO:
            /// error_data, data_ko & error_privacity
            /// are globally injected from PHP controller
            var isValid = true;

            this.cleanErrors();
            this.validated = true;

            if (!this.authorCheck) {
                this.addError(error_data);
                isValid = false;
            }

            // if (!this.emailCheck) {
            //     isValid = false;
            //     this.addError(data_ko);
            // }

            if (!this.commentCheck) {
                isValid = false;
                this.addError(error_data);
            }

            if (!this.privacityCheck) {
                isValid = false;
                this.addError(error_privacity);
            }

            return isValid;
        },

        resetForm: function() {
            this.author = '';
            this.email = '';
            this.web = '';
            this.comment = '';
            this.privacity = false;

            this.validated = false;
            this.cleanErrors();
        },

        onSend: function(response) {

            if (response.data.result !== this.RESPONSE_OK) {
                this.addError(response.data.message);
                return;
            }

            this.successMessage = response.data.message;
            this.resetForm();
        },

        sendForm: function(ev) {
            if (this.validateForm()) {
                axios
                    .post(this.action, this.formData)
                    .then(this.onSend)
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },

        init: function() {
            this.author = this.userName || '';
            this.email = this.userEmail || '';

            this.isInitialized = true;
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <form class="form" id="fmp" name="fmp" enctype="application/x-www-form-urlencoded" method="post" :action="action">\
        <div class="row row--extended">\
            <div class="col-12 col-lg-8">\
\
                <h5 class="post-detail__section-title">{{title}}</h5>\
\
                <div class="row u-mt-l">\
                    <div class="col-12 col-sm-8 col-lg-6">\
                        <div class="form__group form__group--rm-mt" :class="{\'form__group--ko\' : !authorCheck}">\
                            <label class="form__label" for="author">{{authorLabel}}</label>\
                            <div class="form__control-wrapper">\
                                <input class="form__control form-control" v-model="author" id="author" name="author" type="text">\
                            </div>\
                        </div>\
                    </div>\
                </div>\
\
                <div class="row d-none">\
                    <div class="col-12">\
                        <div class="form__group" :class="{\'form__group--ko\' : !emailCheck}">\
                            <label class="form__label" for="email">{{emailLabel}}</label>\
                            <div class="form__control-wrapper">\
                                <input class="form__control form-control" v-model="email" id="email" name="email" type="email">\
                            </div>\
                        </div>\
                    </div>\
                </div>\
\
                <div class="row d-none">\
                    <div class="col-12">\
                        <div class="form__group">\
                            <label class="form__label" for="web">{{webLabel}}</label>\
                            <div class="form__control-wrapper">\
                                <input class="form__control form-control" v-model="web" id="web" name="web" type="url">\
                            </div>\
                        </div>\
                    </div>\
                </div>\
\
                <div class="row">\
                    <div class="col-12">\
                        <div class="form__group" :class="{\'form__group--ko\' : !commentCheck}">\
                            <div class="form__control-wrapper">\
                                <textarea class="form__control form-control form-control--textarea" v-model="comment" id="comment" type="text"></textarea>\
                            </div>\
                        </div>\
                    </div>\
                </div>\
\
                <div class="row">\
                    <div class="col-12">\
                        <div class="form__group">\
                            <label class="checkbox" :class="{\'checkbox--ko\' : !privacityCheck}">\
                                <input type="checkbox" v-model="privacity" id="privacity" name="privacity">\
                                <span class="checkbox__indicator"></span>\
                                <span @click="showLegalConditions" class="checkbox__label" v-html="privacityLabel"></span>\
                            </label>\
                        </div>\
                    </div>\
                </div>\
\
                <div class="container-field form__fsecure" ref="fsecure" id="container-fsecure">\
                    <label for="fsecure"></label>\
                    <div class="content-field content-field-user">\
                        <input class="field_infouser" type="text" name="fsecure" id="fsecure" v-model="fsecure">\
                        <p class="p_error"><span></span></p>\
                    </div>\
                </div>\
\
                <div class="form__validation form__validation--ko" v-if="errors.length">\
                    <p class="form__validation-text" v-for="error in errors">\
                        {{error}}\
                    </p>\
                </div>\
\
                <div class="form__validation form__validation--ok" v-if="successMessage">\
                    <p class="form__validation-text">\
                        {{successMessage}}\
                    </p>\
                </div>\
\
                <div class="form__group">\
                    <input class="btn" id="btn-send" type="submit" :value="sendLabel" @click.prevent="sendForm">\
                </div>\
            </div>\
            <div class="col-12 col-lg-4">\
                <div class="post-detail__form-advice">\
                    <h2 class="post-detail__form-advice-title">{{adviseTitle}}</h2>\
                    <p class="post-detail__form-advice-text">{{adviseContent}}</p>\
                </div>\
            </div>\
        </div>\
    </form>',
});